import PriceField from './PriceField';

export default PriceField;
